import React from 'react';
import { sanitizeContent } from '../../utils/contentSanitizer';
import './RichContentDisplay.css';

interface RichContentDisplayProps {
  content: string;
  className?: string;
  maxHeight?: string;
  showReadMore?: boolean;
  onReadMoreClick?: () => void;
}

const RichContentDisplay: React.FC<RichContentDisplayProps> = ({
  content,
  className = '',
  maxHeight,
  showReadMore = false,
  onReadMoreClick
}) => {
  const sanitizedContent = sanitizeContent(content);

  if (!sanitizedContent) {
    return <div className={`rich-content-display empty ${className}`}>No content available</div>;
  }

  const containerStyle = maxHeight ? { maxHeight, overflow: 'hidden' } : {};

  return (
    <div className={`rich-content-display ${className}`} style={containerStyle}>
      <div
        className="rich-content-body"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
      {showReadMore && onReadMoreClick && (
        <button
          className="read-more-btn"
          onClick={onReadMoreClick}
          type="button"
        >
          Read More
        </button>
      )}
    </div>
  );
};

export default RichContentDisplay;
